import { apiClient } from "@/lib/apiClient";
import type { Organization } from "@/types/organization.types";

export const CURRENT_ORGANIZATION_KEY = "organizations/me";

export const getCurrentOrganization = (): Promise<Organization> =>
  apiClient.get<Organization>(CURRENT_ORGANIZATION_KEY);
